import gql from 'graphql-tag';

export const REDIRECT_ACCOUNT_UNIT = gql`
  mutation RedirectAccountUnit($input: AccountRedirectInput!) {
    redirectAccountUnit(input: $input) {
      redirectIds
    }
  }
`;
